var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      staticClass: "gantt-elastic__chart-dependency-lines-container",
      style: Object.assign(
        {},
        _vm.root.style["chart-dependency-lines-container"]
      ),
      attrs: { x: "0", y: "0", width: "100%", height: "100%" }
    },
    [
      _c("defs", [
        _c(
          "marker",
          {
            style: Object.assign(
              {},
              _vm.root.style["chart-dependency-lines-marker"]
            ),
            attrs: {
              id: "gantt-elastic__chart-dependency-lines-marker",
              viewBox: "0 0 10 10",
              refX: "10",
              refY: "5",
              markerUnits: "strokeWidth",
              markerWidth: "4",
              markerHeight: "4",
              orient: "auto"
            }
          },
          [_c("path", { attrs: { d: "M 0 0 L 10 5 L 0 10 z" } })]
        )
      ]),
      _vm._v(" "),
      _vm._l(_vm.dependencyTasks, function(task) {
        return _c(
          "g",
          { key: task.id, attrs: { task: task } },
          _vm._l(task.dependencyLines, function(dependencyLine) {
            return _c("path", {
              key: dependencyLine.id,
              staticClass: "gantt-elastic__chart-dependency-lines-path",
              style: Object.assign(
                {},
                _vm.root.style["chart-dependency-lines-path"],
                task.style["chart-dependency-lines-path"],
                task.style[
                  "chart-dependency-lines-path-" + dependencyLine.prevTaskId
                ]
              ),
              attrs: {
                task: task,
                d: dependencyLine.points,
                "marker-end":
                  "url(#gantt-elastic__chart-dependency-lines-marker)"
              },
              on: {
                click: function($event) {
                  $event.stopPropagation()
                  return _vm.onDependencyLineClick($event, dependencyLine)
                }
              }
            })
          }),
          0
        )
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }